/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetExamBlockDto
 */
export interface GetExamBlockDto {
    /**
     * 
     * @type {string}
     * @memberof GetExamBlockDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetExamBlockDto
     */
    examId: string;
    /**
     * 
     * @type {string}
     * @memberof GetExamBlockDto
     */
    reason?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetExamBlockDto
     */
    active: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetExamBlockDto
     */
    creationTs?: Date | null;
}

/**
 * Check if a given object implements the GetExamBlockDto interface.
 */
export function instanceOfGetExamBlockDto(value: object): value is GetExamBlockDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('examId' in value) || value['examId'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function GetExamBlockDtoFromJSON(json: any): GetExamBlockDto {
    return GetExamBlockDtoFromJSONTyped(json, false);
}

export function GetExamBlockDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExamBlockDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'examId': json['examId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'active': json['active'],
        'creationTs': json['creationTs'] == null ? undefined : (new Date(json['creationTs'])),
    };
}

export function GetExamBlockDtoToJSON(value?: GetExamBlockDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'examId': value['examId'],
        'reason': value['reason'],
        'active': value['active'],
        'creationTs': value['creationTs'] == null ? undefined : ((value['creationTs'] as any).toISOString()),
    };
}

